module.exports = function getResource(label, vars = []) {
    let resources = {
        mostMention: 'Most Mentioned'
    };
    return resources[label];
};
